module.exports = "/src/views/player/help/images/ems2.jpg";